import edit from './edit';
import softDelete from './soft-delete';

export default {
  edit,
  softDelete,
};
